import { render, staticRenderFns } from "./PoItems.vue?vue&type=template&id=7176c36b&scoped=true&"
import script from "./PoItems.vue?vue&type=script&lang=js&"
export * from "./PoItems.vue?vue&type=script&lang=js&"
import style0 from "./PoItems.vue?vue&type=style&index=0&id=7176c36b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176c36b",
  null
  
)

export default component.exports